// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2pKe5","upload":"Small_upload__CeOky","imageWrap":"Small_imageWrap__1afrF","removeBtn":"Small_removeBtn__1Mwj7"};